import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { deepmerge } from 'deepmerge-ts';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
declare const BUILD_TIME: string;

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public prefix: string[] = ['i18n/', 'i18n/kendo/'],
    public suffix = '.json',
  ) {}

  public getTranslation(lang: string): Observable<TranslationObject> {
    const requests = this.prefix.map((resource) =>
      this.http.get(`${resource}${lang}.json?v=${BUILD_TIME}`),
    );

    return forkJoin(requests).pipe(map((response) => deepmerge(...response) as TranslationObject));
  }
}
